const API_BASE = import.meta.env.PROD ? '/api' : '/api';

function getToken(): string | null {
  return localStorage.getItem('dezoom_token');
}

export function setToken(token: string | null) {
  if (token) localStorage.setItem('dezoom_token', token);
  else localStorage.removeItem('dezoom_token');
}

export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  };
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(data.error || 'request_failed'), { status: res.status, data });
  }
  return data as T;
}

export { getToken };
